/*
 * @Author: Suroc
 * @Date: 2024-07-11 14:15:56
 * @LastEditTime: 2025-01-11 22:54:47
 * @Description: 
 */
const zh = {
  // 头部导航-√
  Header: {
    SuperMarket: "CCR LAND",
    Connect: "连接钱包",
  },
  // 底部导航-√
  Footer: {
    Home: "首页",
    Mining: "农场",
    Profit: "交易",
    Flst: "NFT",
    Team: "我的",
  },
  // 首页-√
  Home: {
    Account: "账号",
    Share: "分享",
    Reference: "推荐人",
    BindWallet: "请先绑定钱包",
    Ecological: "矿机",
    Pledge: "质押",
    Conduct: "理财",
    ToLoan: "借贷",
    Metaverse: "元宇宙",
    ChainGame: "链游",
    ShoppingMall: "商城",
    SwapBut: "探索",
  },
  // 矿机-√
  Mint: {
    OnSale: "在售",
    StopSelling: "停止发售",
    F1MiningMachine: "F1矿机",
    F2MiningMachine: "F2矿机",
    F3MiningMachine: "F3矿机",
    F4MiningMachine: "F4矿机",
    F5MiningMachine: "F5矿机",
    Authorize: "授权",
    BuyNow: "立即购买",
    PurchaseFLST: "购买FLST",
  },
  // 收益-√
  Profit: {
    Hold: "持有矿机价值",
    UnStatic: "未领静态收益",
    UnDynamics: "未领动态收益",
    StaticTotal: "静态总收益（已领取）",
    DynamicTotal: "动态总收益（已领取）",
    MyIncome: "总收益",
    Receive: "领取",
    MyRecord: "我的收益记录",
    Money: "金额-U",
    Quantity: "Token数量",
    Time: "时间",
  },
  // 团队-√
  Team: {
    SuperiorAddress: "上级地址",
    Performance: "我的业绩",
    TeamSize: "我的团队人数",
    Referral: "我的直推人数",
    Direct: "我的团队",
    Address: "地址",
    Money: "金额-U",
    Time: "时间",
    CopyLink: "复制链接",
  },
  // 公共消息弹窗-√
  Prompt: {
    Admin: "无权访问",
    AdminInfo: "获取异常",
    AdminModified: "修改成功",
    AdminModification: "修改失败",
    PurchaseSucceeded: "购买成功",
    PurchaseFailed: "购买失败",
    BindingSucceeded: "绑定成功",
    BindingFailed: "绑定失败",
    ConnectWallet: "请先连接钱包",
    Confirm: "确定",
    Cancel: "取消",
    GoGetIt: "去领取",
    SoldOut: "已售罄",
    NotYetDev: "暂未开放",
    NewIssueSuccess: '领取成功',
    NewIssueError: '领取失败',
    TransactionErr: '交易失败',
    BalanceErr: '余额不足',
    USDTBalanceErr: 'USDT余额不足',
    FLSTBalanceErr: 'FLST余额不足',
    AllowanceErr: '授权不足',
    AllowanceSuccess: '授权成功',
    InviteInfo1: '您通过',
    InviteInfo2: '的邀请访问，是否绑定关系？',
    ProfitInfo: '您有收益未领取，领取后再购买',
    ProfitInfo2: '您没有未领取的收益',
    Fail: "错误"
  },
  nongC: {
    "Home": "首頁",
    "Farm": "農場",
    "Trade": "交易",
    "NFT": "NFT",
    "Mine": "我的",

    "Share": "分享",
    "Referrer": "推薦人",
    "Lv": "當前等級",
    "Bal": "餘額",
    "CHZSoil": "黑鈣土",
    "KSTSoil": "栗鈣土",
    "SRZSoil": "棕鈣土",
    "GRZSoil": "灰鈣土",
    "Plant": "種植",
    "Harvest": "收割",
    "Buy": "購買",
    "TaxRt": "稅率",
    "Prc": "價格",
    "Qty": "數量",
    "Mkt": "市場",
    "Mint": "鑄造",
    "BBox": "盲盒",
    "BuyBBox": "購買盲盒",
    "SellOrder": "掛賣",
    "SellMarket": "掛售",
    "Cancel": "取消",
    "Claim": "領取",
    "ContriDiv": "貢獻值分紅代領取",
    "EquityDiv": "權益值分紅代領取",
    "EquityVal": "權益值",
    "ContriVal": "貢獻值",
    "DivList": "分紅列表",
    "MyTeam": "我的團隊",
    "MyDown": "我的下級",
    "MyUpss": "我的上級",
    "TeamMaxLv": "團隊最高等級",
    "DirectRefPerf": "直推人業績",
    "Bind": "綁定",
 
    "Sale":"出售",
    "HistoryPrice":"历史均价",
    "Error":"错误"
  }

  ,
  common: {
    "crzfh": "C認證分紅",
    "contri": "貢獻值分紅",
    "contriAmount": "分紅金額",
    "myArea": "我的領域",
    "myBind": "我的綁定",
    "noBind": "暫無綁定",
    "ktAdress": "開拓地址",
    "crz": "C認證",
    "qyz": "權益值",
    "none": "無",
    "payAmount": "支付數量",
    "sale": "出售",
    "amount": "數量",
    "investment": "投入",
    "released": "已釋放",
    "cycle": "週期",
    "plantTime": "種植時間",
    "lastHarvest": "成熟時間",
    "harvest": "收割",
    "hgt": "黑鈣土",
    "lgt": "栗鈣土",
    "zgt": "棕鈣土",
    "huigt": "灰鈣土",
    "plantNow": "立即種植",
    "makeSure": "確定",
    "czzqsh": "操作中，請稍後...",
    "ljqdts": "累計簽到天數：",
    "dh": "兌換",
    "wqd": "未簽到",
    "dqd": "待簽到",
    "kfzqdd": "開發中請等待",
    "gqbzwjrqx": "該錢包暫無進入權限",
    "zwkf": "暫未開放",
    "sqcg": "授權成功",
    "sqsb": "授權失敗",
    "zzcg": "鑄造成功",
    "zzsb": "鑄造失敗",
    "dkcg": "打開成功",
    "dksb": "打開失敗",
    "cg": "成功",
    "sb": "失敗",
    "open": "打開",
    "buy": "購買",
    "free": "免費",
    "zzhqsj": "正在獲取數據",
    "zwtjr": "暫無推薦人",
    "destroy": "銷毀",
    "sywcc": "剩餘未產出",
    "dhfm": "10天23時15分15秒",
    "xcrq": "下次日期",
    "zwzsdnft": "暫無在售的NFT",
    "mc": "名稱：",
    "fortyfiveDay": "天",
    "uybind": "你要綁定",
    "zgyqmm": "這個邀請碼嗎？",
    "zwyqm": "暫無邀請碼",
    "wcxdyqm": "未查詢到邀請碼",
    "bindSuccess": "綁定完成",
    "zwkf": "暫未開放",
    "lq": "偷",
    "fail": "失敗",
    "mygdl": "沒有更多了",
    "jine": "金額：",
    "shijian": "時間：",
    "tq": "提取",
    "tqd": "已提取",
    "dsf": "待釋放",
    "zzsf": "正在釋放",
    "sfwc": "釋放完成",
    "jz": "價值：",

     "zz": "種植", 
     "zq": "週期",
     "Hour":"时",
     "Day":"天",
     "Min":"分",
      "Sec":"秒",
      "limit":"剩余可用",
      "tq":"免费偷取",



      "dlq": "待領取",
      "Harvest2": "一鍵收取",
      "St": "已偷取",
      "Telegram": "TG",
      "Home": "官網",
      "CChat": "CChat",
      "Knowlage": "資料庫",
      "SALE": "出售",
      "BUY": "購買",


      "availableBalance": "可用餘額",
      "dailyClaimsLeft": "當日剩餘次數",
      "userClaimsLeft": "您的剩餘次數",
      "userClaims": "您未使用的",
             "history":"歷史",
       "My sales": "我的銷售",
       "token": "代币",
       "price": "价格", 
       "total": "总额"
     },
  signatureGuard: {
    connectWallet: "連接錢包",
    connectDescription: "請連接您的錢包以驗證身份並訪問您的個人信息",
    connecting: "連接中...",
    connect: "連接錢包",
    signatureRequired: "需要簽名驗證",
    signatureDescription: "為了確保安全，請簽名驗證您的錢包地址",
    currentWallet: "當前錢包",
    signing: "簽名中...",
    sign: "簽名驗證",
    verificationFailed: "驗證失敗",
    retry: "重試",
    disconnect: "斷開連接",
    walletConnected: "錢包連接成功",
    connectionFailed: "錢包連接失敗",
    connectionError: "連接錯誤",
    noWalletAddress: "無法獲取錢包地址",
    noProvider: "未檢測到錢包提供商",
    signatureSuccess: "簽名驗證成功",
    userRejected: "用戶拒絕簽名",
    signatureError: "簽名失敗",
    noSignMessage: "缺少簽名消息",
    addressMismatch: "簽名地址與當前地址不匹配",
    verificationError: "驗證錯誤",
    walletDisconnected: "錢包已斷開連接"
  }
}
export default zh;